<template>
  <form autocomplete="off">
    <div class="mb-4">
      <span class="body-1 mb-4 primary--text font-weight-medium"
        >Datos personales</span
      >
    </div>

    <v-text-field
      v-model="practitioner.email"
      label="Email"
      type="email"
      outlined
      rounded
      :rules="[() => !!practitioner.email || 'Campo requerido']"
    ></v-text-field>

    <v-text-field
      v-model="practitioner.name"
      label="Nombre completo"
      outlined
      rounded
      required
    ></v-text-field>

    <v-text-field
      v-model="practitioner.phone"
      prefix="+56"
      required
      label="Teléfono"
      clearable
      type="number"
      rounded
      outlined
      :rules="[
        () => !!practitioner.phone || 'Campo requerido',
        () => isValidPhone || 'Formato requerido'
      ]"
    ></v-text-field>

    <div class="mb-4">
      <span class="body-1 primary--text font-weight-medium"
        >Configuración cuenta</span
      >
    </div>

    <v-text-field
      v-model="practitioner.password"
      label="Contraseña"
      :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
      :type="showPassword ? 'text' : 'password'"
      @click:append="showPassword = !showPassword"
      rounded
      outlined
      :rules="[() => !!practitioner.password || 'Campo requerido']"
    ></v-text-field>

    <v-text-field
      v-model="practitioner.passwordConfirmed"
      label="Repita contraseña"
      outlined
      :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
      :type="showPassword ? 'text' : 'password'"
      @click:append="showPassword = !showPassword"
      rounded
      :rules="[
        () => !!practitioner.password || 'Campo requerido',
        () =>
          practitioner.password == practitioner.passwordConfirmed ||
          'Contraseñas no coinciden'
      ]"
    ></v-text-field>

    <p class="primary--text font-weight-medium">
      <v-icon left color="primary">mdi-file-document-edit</v-icon>Al registrarme
      estoy aceptando
      <a class="font-weight-bold" @click="dialogTerms = true"
        >términos de uso</a
      >
    </p>

    <v-dialog v-model="dialogTerms" max-width="500">
      <v-card>
        <v-card-title class="primary--text">Términos de Uso</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-8">
          <span>
            CostaPez no garantiza la precisión y exactitud en los registros de
            biodiversidad. A pesar de que nuestro equipo se encarga de revisar
            constantemente los registros, la identificación y metadata asociada
            a estos es responsabilidad de cada usuario. En caso de que quieras
            reportar una incongruencia escríbenos a contacto@costapez.org.
          </span>
        </v-card-text>
        <v-card-text>
          <span class="pt-2">
            Como proyecto creemos en compartir información de manera libre, y
            para dar tranquilidad a nuestros usuarios declaramos que el
            contenido vertido en nuestra plataforma se encuentra bajo una
            licencia equivalente a la detallada por “Creative Commons”: CC
            BY-NC-SA (Attribution-NonCommercial- ShareAlike). Esta licencia
            permite a otros remezclar, adaptar y construir sobre su trabajo de
            manera siempre y cuando no sea utilizada con fines comerciales,
            siempre que reporten la autoría y sus nuevas creaciones otorguen
            licencias bajo los mismos términos.
          </span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialogTerms = false" color="primary" rounded
            >Aceptar y volver</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </form>
</template>

<script>
export default {
  props: ["practitioner"],
  data: () => ({
    genderList: ["Masculino", "Femenino", "Prefiere no decir"],
    dialogTerms: false,
    showPassword: false
  }),
  computed: {
    isValidPhone() {
      let { phone = "" } = this.practitioner;
      return !isNaN(phone) && phone.length == 9;
    }
  }
};
</script>

<style></style>
